
import React from 'react';
import { Button } from '@/components/ui/button';
import { Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SubmitButtonProps {
  isSubmitting: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isSubmitting }) => {
  const { t } = useTranslation();
  
  return (
    <Button 
      type="submit" 
      disabled={isSubmitting}
      className="w-full bg-brand-primary hover:bg-brand-primary/90 text-brand-primary-foreground"
    >
      {isSubmitting ? t('common.loading') : (
        <span className="flex items-center gap-2">
          <Send className="w-4 h-4" />
          {t('interview.sendRequest')}
        </span>
      )}
    </Button>
  );
};

export default SubmitButton;
